import { TERM_LENGTH_FORMAT } from './constants';

function getYearFormat({ format, unit }: { format: TERM_LENGTH_FORMAT; unit: number }) {
  const isPlural = unit > 1;

  switch (format) {
    case TERM_LENGTH_FORMAT.abv:
      return 'yr';
    case TERM_LENGTH_FORMAT.hyphen:
      return '-year';
    case TERM_LENGTH_FORMAT.full_term:
    default:
      return isPlural ? ' years' : ' year';
  }
}

function getMonthFormat({ format, unit }: { format: TERM_LENGTH_FORMAT; unit: number }) {
  const isPlural = unit > 1;

  switch (format) {
    case TERM_LENGTH_FORMAT.abv:
      return 'mo';
    case TERM_LENGTH_FORMAT.hyphen:
      return '-month';
    case TERM_LENGTH_FORMAT.full_term:
    default:
      return isPlural ? ' months' : ' month';
  }
}

export function formatLabel({
  cdDepositTerm,
  format = TERM_LENGTH_FORMAT.full_term,
  displayName,
}: {
  cdDepositTerm?: number;
  format?: TERM_LENGTH_FORMAT;
  displayName?: string;
}) {
  if (!cdDepositTerm) {
    return;
  }

  let suffix = '';

  if (displayName?.match(/bump|\braise\b/i)) {
    suffix = ' bump-up';
  } else if (displayName?.match(/no.*?penalty/i)) {
    suffix = ' no-penalty';
  } else if (displayName?.match(/jumbo/i)) {
    suffix = ' jumbo';
  }

  const months = Math.round(cdDepositTerm / 30);
  if (months % 12 === 0) {
    const years = months / 12;
    return years + getYearFormat({ format, unit: years }) + suffix;
  }

  return months + getMonthFormat({ format, unit: months }) + suffix;
}
